/* eslint-disable max-lines */
import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import { RadioOptionsField, TextField } from "../../../components";
import { CustomMultiLineTextField } from "../../../components/CustomMultiLineTextField/CustomMultiLineTextField";
import { SubForm, SubFormNavigationProps } from "../../../components/SubForm";
import {
  pitchAskForXboxInitialValues,
  pitchInputsMaxLength,
  usePitchInformationAskForXboxValidationSchema,
} from "../../../helpers/formValidation";
import { useStrings } from "../../../localization/localizationHelpers";
import { FundingSoughtOptions } from "../../../models/pitchUxModels";
import { getIsSavingForm } from "../../../redux/selectors";
import {
  PitchInformationFormId,
  PitchInformationSubFormsId,
} from "../PitchInformationPageConstants";
import * as styles from "../PublisherDeveloperSubForm/PublisherDeveloperSubForm.module.css";

const AskForXboxSubForm = (props: SubFormNavigationProps) => {
  const [
    pitchAskForXboxFundingSoughtTitle,
    yes,
    no,
    other,
    pitchAskForXboxFundingSoughtDetailsTitle,
    pitchAskForXboxFundingSoughtDetailsSubtitle,
    pitchAskForXboxOtherSupportNeededTitle,
  ] = useStrings(
    "pitchAskForXboxFundingSoughtTitle",
    "yes",
    "no",
    "other",
    "pitchAskForXboxFundingSoughtDetailsTitle",
    "pitchAskForXboxFundingSoughtDetailsSubtitle",
    "pitchAskForXboxOtherSupportNeededTitle"
  );

  const validationSchema = usePitchInformationAskForXboxValidationSchema();
  const isSavingFormToCrm = useSelector(getIsSavingForm);
  const [isFundingSoughtOtherChecked, setIsFundingSoughtOtherChecked] = useState<
    boolean | undefined
  >(undefined);

  return (
    <SubForm
      validateConfig={validationSchema}
      initialValues={pitchAskForXboxInitialValues}
      formId={PitchInformationFormId}
      subFormId={PitchInformationSubFormsId.AskForXbox}
      {...props}
    >
      <Row className={styles.container}>
        <Column>
          <RadioOptionsField
            options={[
              {
                value: FundingSoughtOptions.Yes,
                label: yes,
              },
              {
                value: FundingSoughtOptions.No,
                label: no,
              },
              {
                value: FundingSoughtOptions.Other,
                label: other,
              },
            ]}
            listAsColumn
            name={"fundingSought"}
            title={pitchAskForXboxFundingSoughtTitle}
            isSaving={isSavingFormToCrm}
            isRequiredField
            setChildInputForm={setIsFundingSoughtOtherChecked}
          />
          <CustomMultiLineTextField
            name="fundingSoughtDetails"
            title={pitchAskForXboxFundingSoughtDetailsTitle}
            subtitle={pitchAskForXboxFundingSoughtDetailsSubtitle}
            isRequiredField={isFundingSoughtOtherChecked}
            isSaving={isSavingFormToCrm}
            parentChecked={isFundingSoughtOtherChecked}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <TextField
            name="otherSupportNeeded"
            title={pitchAskForXboxOtherSupportNeededTitle}
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
        </Column>
      </Row>
    </SubForm>
  );
};

export default AskForXboxSubForm;
